<template>
    <div class="cbd-nav-map cbd-plate" :data-spm="spmCCode" v-if="navData">
        <header class="cbd-plate-head">
            <h2>{{siteName}}</h2>
        </header>
        <footer class="footer-navs-wrapper">
            <ul class="navs-area">
                <li v-for="(nav, index) in navData" :key="index" class="item">
                    <a :href="nav.url" class="btn">{{nav.title}}</a>
                </li>
            </ul>
        </footer>
    </div>
</template>

<script>
import { getOdinData } from '@/js/request/odinRequest'
import { getOdinResourceIdMap } from "@/config/odinResourceIds"

export default {
    name: 'NavMap',
    data(){
        return{
            spmCCode:'navmap',
            siteName:'网站地图',
            navData: null, // 网站地图数据
        }
    },
    mounted(){
        this.getNavData()
    },
    methods:{
        async getNavData() {
            const idsMap = getOdinResourceIdMap('navmap')
            const tplCompKey = 'navmap'
            const spmObj = window?.sohuSpm?.getCodes()
            const params = {
                tplCompKey,
                adInfo: idsMap?.adInfo,
                spmCCode: idsMap?.spmCCode,
                resourceId: idsMap?.resourceId,
                content: {
                    page: 1,
                    size: 20,
                    productId: idsMap?.productId,
                    productType: idsMap?.productType,
                    spm: `${spmObj?.a}.${spmObj?.b}.${idsMap?.spmCCode}`
                }
            }
            let res = await getOdinData(params)
            if(res?.list?.length) {
                this.navData = res?.list || []
            }
        }
    }
}
</script>

<style scoped lang="less">
    //网站地图
    .cbd-nav-map {
        @fontColor: #656565;
        border-bottom: none;
        background-color: #ffffff;
        // 版块标题
        .cbd-plate-head {
            position: relative;
            padding-top: 30px;
            padding-bottom: 30px;
            padding-right: 26px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            // height: 38px;
            h2 {
                margin: 0;
                position: relative;
                font-size: 36px; /*px*/
                line-height: 50px; /*px*/
                color:#3c3c3d;
                font-weight: bold;
                padding-left: 28px;
            }
            .hot-tags {
                display: flex;
                align-items: center;
                .btn {
                    padding-left: 36px;
                    text-align: center;
                    font-size: 32px; /*px*/
                    color: #656565;
                }
            }
        }
        &.article{
            h2{
                color: @fontColor;
                font-size: 32px; /*px*/
                padding-left: 26px;
                .vline{
                    display: none;
                }
            }
        }
        .title {
            padding: 48px 28px 24px;
            font-weight: 500;
            font-size: 30px; /*px*/
        }
        .footer-navs-wrapper {
            width: 100%;
            padding-bottom: 36px;
            overflow: hidden;
        }
        .navs-area {
            margin: 0;
            padding: 0px 28px;
            .item {
                float: left;
                width: 16.666667%;
                text-align: left;
                height: 44px;
                line-height: 44px;
                margin-bottom: 24px;
                font-size: 32px; /*px*/
                list-style: none;
                overflow: hidden;
                .btn {
                    color: @fontColor;
                    text-decoration: none;
                }
            }

        }
    }
</style>
